export const colors = {
  f: '#ffffff',
  black: '#3A4069',
  lightgrey: '#fafafa',
  midgrey: '#DFE4EC',
  darkgrey: '#b5b5b5',
  text: '#303030',
  red: ' #C5292A',
  lightRed: '#f9e9e9',
  blue: '#0e64ff',
  lightBlue: '#ECF3FF',
  bluehover: '#0a55dc',
  green: '#0ABA61',
  lightGreen: '#E3F7ED',
  Yellow: '#FBBF2E',
  lightYellow: '#FFF3D6',
};

export const shadow = {
  shadow: '0px 4px 4px rgba(221, 221, 221, 0.25)',
};

export default {
  colors,
  shadow,
};
